import { render, staticRenderFns } from "./Addon.vue?vue&type=template&id=118acedb&scoped=true&"
import script from "./Addon.vue?vue&type=script&lang=js&"
export * from "./Addon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118acedb",
  null
  
)

export default component.exports